export const siteName = "网红黑料";

export const siteTagline = "每日更新 · 实时吃瓜";

export const heroSlogan = "海量网红八卦内幕，一手塌房翻车丑闻，满足你的吃瓜好奇心";

export const heroStats = [
  { label: "每日更新爆料", value: "24h 不间断" },
  { label: "覆盖网红数量", value: "3000+ 位" },
  { label: "累计独家黑料", value: "10w+ 条" },
];

export const features = [
  {
    title: "实时追踪",
    description: "7×24小时不间断监控网红动态，第一时间捕捉塌房翻车信号，让你永远走在吃瓜第一线。",
    icon: "ri-radar-line",
  },
  {
    title: "独家深扒",
    description: "专业团队深度挖掘网红背后不为人知的内幕，还原事件真相，拒绝断章取义。",
    icon: "ri-search-eye-line",
  },
  {
    title: "海量爆料",
    description: "汇聚全网最新网红黑料与八卦资讯，从感情纠葛到商业翻车，一网打尽。",
    icon: "ri-database-2-line",
  },
  {
    title: "有图有真相",
    description: "每条爆料均附带截图、录屏等实锤证据，不凭空捏造，让你吃得明明白白。",
    icon: "ri-image-add-line",
  },
  {
    title: "吃瓜社区",
    description: "千万吃瓜群众在线互动，评论、讨论、补充线索，一起围观网红翻车现场。",
    icon: "ri-group-line",
  },
];

export const cards = [
  {
    title: "知名美妆博主「小鹿酱」偷税漏税被查，补缴罚款超千万",
    category: "塌房实锤",
    excerpt: "据知情人士透露，拥有2000万粉丝的美妆博主小鹿酱因涉嫌偷逃税款被税务部门调查，目前已被要求补缴税款及滞纳金共计1200余万元。其合作的多个品牌已紧急下架相关产品。",
    date: "2026-07-29",
    imageUrl: "https://readdy.ai/api/search-image?query=Dramatic%20dark%20red%20and%20black%20abstract%20composition%20with%20shattered%20glass%20texture%2C%20mysterious%20atmosphere%2C%20editorial%20journalism%20style%2C%20warm%20amber%20accents%2C%20high%20contrast%2C%20cinematic%20lighting%2C%20clean%20minimal%20background&width=800&height=500&seq=card-01&orientation=landscape",
    tags: ["偷税漏税", "美妆博主", "塌房"],
  },
  {
    title: "游戏主播「阿飞」人设崩塌，私下辱骂粉丝录音曝光",
    category: "人设翻车",
    excerpt: "一段疑似游戏主播阿飞的私下对话录音在网络流传，录音中其多次使用侮辱性词汇评价粉丝，与此前塑造的暖心主播形象严重不符，引发粉丝大规模脱粉。",
    date: "2026-07-28",
    imageUrl: "https://readdy.ai/api/search-image?query=Dark%20dramatic%20abstract%20composition%20with%20fractured%20digital%20waveforms%2C%20deep%20crimson%20and%20charcoal%20tones%2C%20mysterious%20edgy%20aesthetic%2C%20modern%20journalism%20style%2C%20soft%20contrast%20overlay&width=800&height=500&seq=card-02&orientation=landscape",
    tags: ["人设崩塌", "游戏主播", "录音曝光"],
  },
  {
    title: "情侣网红「甜心CP」分手内幕：疑似一方劈腿经纪人",
    category: "感情瓜",
    excerpt: "拥有500万粉丝的情侣网红账号「甜心CP」突然停更，随后有网友扒出女方与经纪人的亲密合照，引发劈腿猜测。双方目前均未对此事做出正式回应。",
    date: "2026-07-27",
    imageUrl: "https://readdy.ai/api/search-image?query=Abstract%20dark%20composition%20with%20two%20separating%20geometric%20shapes%2C%20warm%20amber%20and%20crimson%20gradients%2C%20mysterious%20emotional%20atmosphere%2C%20editorial%20photo%20style%2C%20clean%20background&width=800&height=500&seq=card-03&orientation=landscape",
    tags: ["情侣网红", "劈腿", "分手内幕"],
  },
  {
    title: "带货一哥「老陈」直播间售假被实锤，品牌方集体解约",
    category: "商业翻车",
    excerpt: "职业打假人发布检测报告指认老陈直播间销售的多款护肤品为假冒伪劣产品。消息传出后，已有6家品牌宣布与其终止合作，老陈直播间粉丝一夜暴跌80万。",
    date: "2026-07-26",
    imageUrl: "https://readdy.ai/api/search-image?query=Dark%20abstract%20composition%20with%20broken%20product%20boxes%20and%20falling%20labels%2C%20deep%20red%20accents%2C%20mysterious%20dramatic%20mood%2C%20editorial%20documentary%20style%2C%20high%20contrast%20lighting&width=800&height=500&seq=card-04&orientation=landscape",
    tags: ["直播带货", "假货", "品牌解约"],
  },
  {
    title: "健身网红「铁柱哥」被曝使用类固醇，肌肉造假引争议",
    category: "造假曝光",
    excerpt: "有医学专业人士分析了铁柱哥的体型变化曲线，指出其肌肉增长速度远超自然训练极限。随后更有业内人士爆料其长期使用多种违禁药物，健身圈一片哗然。",
    date: "2026-07-25",
    imageUrl: "https://readdy.ai/api/search-image?query=Abstract%20dark%20composition%20with%20cracked%20surface%20texture%20revealing%20hollow%20interior%2C%20warm%20amber%20and%20deep%20red%20tones%2C%20mysterious%20atmosphere%2C%20editorial%20style%2C%20clean%20minimal%20background&width=800&height=500&seq=card-05&orientation=landscape",
    tags: ["健身网红", "药物造假", "人设争议"],
  },
  {
    title: "美食博主「大嘴吃四方」被指抄袭，三年内容多篇雷同",
    category: "抄袭风波",
    excerpt: "网友整理对比发现，大嘴吃四方的近百条视频内容与海外多个美食频道高度雷同，从选题、分镜到文案均有明显抄袭痕迹，目前其已删除争议视频并发布道歉声明。",
    date: "2026-07-24",
    imageUrl: "https://readdy.ai/api/search-image?query=Dark%20abstract%20composition%20with%20overlapping%20mirrored%20patterns%2C%20deep%20crimson%20and%20charcoal%20shades%2C%20mysterious%20tension%2C%20editorial%20journalism%20aesthetic%2C%20clean%20background&width=800&height=500&seq=card-06&orientation=landscape",
    tags: ["美食博主", "内容抄袭", "道歉声明"],
  },
  {
    title: "古风网红「青衣公子」慈善捐款疑云，善款去向不明",
    category: "公益质疑",
    excerpt: "青衣公子此前高调宣布将直播收益的30%捐赠给山区儿童，但有网友发现其公布的捐款凭证存在PS痕迹，涉及金额超200万元，目前相关慈善机构已介入核查。",
    date: "2026-07-23",
    imageUrl: "https://readdy.ai/api/search-image?query=Abstract%20dark%20composition%20with%20fading%20receipts%20and%20questionable%20documents%2C%20warm%20amber%20highlights%2C%20mysterious%20atmosphere%2C%20editorial%20investigative%20style%2C%20clean%20background&width=800&height=500&seq=card-07&orientation=landscape",
    tags: ["古风网红", "慈善造假", "善款疑云"],
  },
];

export const indexItems = [
  { title: "塌房明星全收录", count: 128, icon: "ri-swap-line", href: "#cards" },
  { title: "感情纠纷吃瓜区", count: 96, icon: "ri-hearts-line", href: "#cards" },
  { title: "直播翻车名场面", count: 85, icon: "ri-live-line", href: "#cards" },
  { title: "人设崩塌档案库", count: 74, icon: "ri-user-unfollow-line", href: "#cards" },
  { title: "商业丑闻曝光台", count: 63, icon: "ri-money-cny-box-line", href: "#cards" },
  { title: "法律纠纷追踪站", count: 51, icon: "ri-scales-line", href: "#cards" },
  { title: "造假打假擂台赛", count: 47, icon: "ri-shield-flash-line", href: "#cards" },
  { title: "饭圈大战实况台", count: 42, icon: "ri-fire-line", href: "#cards" },
  { title: "网红圈内潜规则", count: 39, icon: "ri-eye-off-line", href: "#cards" },
];

export const aboutText = "网红黑料网是国内领先的网红八卦与内幕资讯聚合平台。我们致力于为全网吃瓜群众提供最新、最全、最真实的网红黑料与塌房翻车资讯。团队由资深娱乐记者、数据挖掘工程师和热心网友共同组成，通过多渠道交叉验证的方式，确保每一条爆料的真实性和时效性。在信息爆炸的时代，我们坚持有图有真相，拒绝标题党和虚假炒作，用严谨的态度对待每一条网红丑闻，用专业的精神服务每一位吃瓜群众。";

export const topics = [
  { name: "#网红塌房", heat: "🔥 爆", count: 12500 },
  { name: "#直播翻车", heat: "🔥 热", count: 10800 },
  { name: "#人设崩塌", heat: "🔥 热", count: 9200 },
  { name: "#偷税漏税", heat: "📈 升", count: 7600 },
  { name: "#假货带货", heat: "📈 升", count: 6800 },
  { name: "#劈腿出轨", heat: "🔥 热", count: 6400 },
  { name: "#粉丝脱粉", heat: "📈 升", count: 5500 },
  { name: "#抄袭曝光", heat: "🆕 新", count: 4800 },
  { name: "#慈善造假", heat: "🆕 新", count: 3900 },
  { name: "#合同纠纷", heat: "📈 升", count: 3200 },
  { name: "#违规广告", heat: "🆕 新", count: 2800 },
];

export const carouselItems = [
  {
    title: "深度专题：2026上半年网红塌房大事件盘点",
    excerpt: "从偷税漏税到人设崩塌，从直播翻车到感情纠葛，2026年上半年网红圈风波不断。本文为你梳理上半年最具影响力的十大网红塌房事件，深度解析背后的行业乱象与粉丝经济的隐忧。",
    imageUrl: "https://readdy.ai/api/search-image?query=Dramatic%20dark%20abstract%20composition%20with%20collage%20of%20shattered%20screens%20and%20falling%20stars%2C%20deep%20crimson%20ambient%20light%2C%20mysterious%20cinematic%20atmosphere%2C%20editorial%20magazine%20cover%20style%2C%20high%20contrast%2C%20clean%20minimal%20background%20elements&width=1000&height=600&seq=carousel-01&orientation=landscape",
    tag: "年度盘点",
  },
  {
    title: "起底「MCN机构」：网红经纪公司的灰色地带",
    excerpt: "MCN机构究竟是网红的伯乐还是吸血鬼？本文通过多位业内人士的独家爆料，揭开MCN机构在签约、分成、账号控制等方面的不为人知的行业内幕。",
    imageUrl: "https://readdy.ai/api/search-image?query=Dark%20mysterious%20abstract%20composition%20with%20behind%20the%20scenes%20corporate%20shadow%20figures%2C%20warm%20amber%20and%20deep%20red%20tones%2C%20investigative%20journalism%20atmosphere%2C%20clean%20minimal%20background&width=1000&height=600&seq=carousel-02&orientation=landscape",
    tag: "行业深扒",
  },
  {
    title: "从顶流到查无此人：那些一夜消失的网红去哪了？",
    excerpt: "他们曾是平台顶流，拥有千万粉丝和亿万流量，却在某个节点突然销声匿迹。本文追踪多位「消失网红」的近况，还原他们从巅峰跌落的真实原因。",
    imageUrl: "https://readdy.ai/api/search-image?query=Abstract%20dark%20composition%20showing%20fading%20silhouettes%20disappearing%20into%20shadows%2C%20warm%20amber%20light%20trails%2C%20mysterious%20melancholic%20mood%2C%20editorial%20documentary%20style%2C%20clean%20background&width=1000&height=600&seq=carousel-03&orientation=landscape",
    tag: "失踪档案",
  },
  {
    title: "网红收入大揭秘：头部主播一年到底能赚多少钱？",
    excerpt: "直播打赏、品牌代言、带货佣金、平台签约费……网红们的收入来源远比想象中复杂。我们独家获取了多位头部网红的不完全收入数据，揭开花花世界背后的真实数字。",
    imageUrl: "https://readdy.ai/api/search-image?query=Dark%20abstract%20composition%20with%20scattered%20currency%20symbols%20and%20hidden%20numbers%2C%20deep%20crimson%20glow%2C%20mysterious%20financial%20atmosphere%2C%20editorial%20investigative%20style%2C%20clean%20background&width=1000&height=600&seq=carousel-04&orientation=landscape",
    tag: "财富密码",
  },
  {
    title: "网红圈的「剧本」文化：你以为的真实都是演的",
    excerpt: "从情侣CP到家庭纠纷，从街头偶遇到慈善捐赠，越来越多的网红内容被证实是有剧本的精心策划。本文揭开网红内容工业化的运作模式，让你看清屏幕背后的真相。",
    imageUrl: "https://readdy.ai/api/search-image?query=Abstract%20dark%20composition%20with%20theater%20curtains%20revealing%20hidden%20scripts%2C%20warm%20amber%20spotlight%2C%20mysterious%20backstage%20atmosphere%2C%20editorial%20revealing%20style%2C%20clean%20background&width=1000&height=600&seq=carousel-05&orientation=landscape",
    tag: "行业揭秘",
  },
  {
    title: "粉丝经济背后的灰色产业链：刷量、控评、数据造假",
    excerpt: "一条龙的数据造假服务如何让普通素人「变成」百万网红？本文深度调查粉丝经济背后的灰色产业链，揭开刷量平台、水军公司和数据工坊的真实运作方式。",
    imageUrl: "https://readdy.ai/api/search-image?query=Dark%20abstract%20composition%20with%20robot%20hands%20typing%20on%20multiple%20screens%2C%20deep%20crimson%20glow%2C%20mysterious%20tech%20atmosphere%2C%20editorial%20investigative%20style%2C%20clean%20background&width=1000&height=600&seq=carousel-06&orientation=landscape",
    tag: "灰色产业",
  },
];

export const updates = [
  { time: "10分钟前", content: "知名舞蹈网红「小天鹅」被前助理实名举报偷税漏税，涉及金额或达800万元", href: "#cards" },
  { time: "28分钟前", content: "带货主播「胖虎」直播间被封禁，疑似因虚假宣传保健品功效被多人投诉", href: "#cards" },
  { time: "1小时前", content: "旅行博主「环游日记」被曝酒店测评收钱说好话，多家五星酒店牵涉其中", href: "#cards" },
  { time: "2小时前", content: "二次元Coser「樱花兔」被扒出与多名男性粉丝保持暧昧关系，人设彻底崩塌", href: "#cards" },
  { time: "3小时前", content: "科技博主「极客大叔」评测数据造假被同行实锤，多个品牌紧急终止合作", href: "#cards" },
  { time: "5小时前", content: "农村网红「田园阿婆」被指团队包装，真实身份竟是城市白领，网友直呼被骗", href: "#cards" },
  { time: "7小时前", content: "美妆博主「兔兔酱」自创品牌被检测出违禁成分，已有多名消费者出现过敏反应", href: "#cards" },
];

export const comments = [
  {
    user: "吃瓜不嫌事大",
    avatar: "A",
    time: "3分钟前",
    content: "小鹿酱这个瓜我吃了三天了，越来越有意思，坐等官方通报！果然网红圈没有一个是干净的。",
    likes: 2341,
  },
  {
    user: "八卦侦查员",
    avatar: "八",
    time: "15分钟前",
    content: "作为一个老吃瓜人，我只能说网红黑料网的爆料速度是真的快，比微博热搜还早半天，关注三年了从来没让我失望过。",
    likes: 1823,
  },
  {
    user: "理性吃瓜群众",
    avatar: "理",
    time: "42分钟前",
    content: "建议大家在吃瓜的时候保持理性，虽然黑料看着很过瘾，但也要留一点辩证思考的空间，不要被情绪带着走。",
    likes: 1567,
  },
  {
    user: "瓜田守望者",
    avatar: "瓜",
    time: "1小时前",
    content: "铁柱哥那个药物造假的瓜太劲爆了！我之前就觉得他的肌肉比例不对劲，果然是用了科技啊。",
    likes: 1298,
  },
  {
    user: "深夜吃瓜人",
    avatar: "夜",
    time: "2小时前",
    content: "每天晚上睡前必须刷一遍网红黑料网，已经成为习惯了。今天的更新质量很高，推荐首页的那篇MCN深扒文章写得真好。",
    likes: 1045,
  },
];

export const mediaItems = [
  {
    title: "【独家曝光】某百万粉网红后台辱骂工作人员完整录像",
    duration: "03:25",
    imageUrl: "https://readdy.ai/api/search-image?query=Dark%20cinematic%20abstract%20composition%20with%20play%20button%20and%20grainy%20footage%20texture%2C%20deep%20crimson%20glow%2C%20mysterious%20surveillance%20atmosphere%2C%20editorial%20documentary%20style%2C%20clean%20background&width=800&height=500&seq=media-01&orientation=landscape",
  },
  {
    title: "网红直播翻车集锦：那些尴尬到脚趾抠地的名场面",
    duration: "08:12",
    imageUrl: "https://readdy.ai/api/search-image?query=Abstract%20dark%20composition%20with%20multiple%20glitched%20video%20screens%2C%20warm%20amber%20highlights%2C%20chaotic%20mysterious%20energy%2C%20editorial%20compilation%20style%2C%20clean%20background&width=800&height=500&seq=media-02&orientation=landscape",
  },
  {
    title: "深度对话：前MCN运营总监揭秘网红签约内幕",
    duration: "15:40",
    imageUrl: "https://readdy.ai/api/search-image?query=Dark%20abstract%20composition%20with%20interview%20silhouette%20and%20hidden%20documents%2C%20deep%20crimson%20and%20amber%20mood%20lighting%2C%20mysterious%20confidential%20atmosphere%2C%20editorial%20style%2C%20clean%20background&width=800&height=500&seq=media-03&orientation=landscape",
  },
  {
    title: "塌房预警：近期可能翻车的网红名单及原因分析",
    duration: "06:58",
    imageUrl: "https://readdy.ai/api/search-image?query=Dark%20abstract%20composition%20with%20warning%20signals%20and%20falling%20dominoes%2C%20warm%20amber%20alert%20glow%2C%20mysterious%20predictive%20atmosphere%2C%20editorial%20style%2C%20clean%20background&width=800&height=500&seq=media-04&orientation=landscape",
  },
  {
    title: "网红黑料年度盛典：2025最劲爆塌房瞬间回顾",
    duration: "12:30",
    imageUrl: "https://readdy.ai/api/search-image?query=Dark%20abstract%20composition%20with%20award%20podium%20shattering%2C%20deep%20crimson%20celebratory%20glow%2C%20mysterious%20dramatic%20atmosphere%2C%20editorial%20showcase%20style%2C%20clean%20background&width=800&height=500&seq=media-05&orientation=landscape",
  },
];

export const rankingItems = [
  { rank: 1, title: "美妆博主小鹿酱偷税案", heat: "12.5w", trend: "up", href: "#cards" },
  { rank: 2, title: "游戏主播阿飞辱骂粉丝", heat: "10.8w", trend: "up", href: "#cards" },
  { rank: 3, title: "带货老陈直播间假货门", heat: "9.2w", trend: "stable", href: "#cards" },
  { rank: 4, title: "甜心CP劈腿经纪人内幕", heat: "7.6w", trend: "up", href: "#cards" },
  { rank: 5, title: "健身铁柱哥药物造假", heat: "6.4w", trend: "down", href: "#cards" },
];

export const faqItems = [
  {
    question: "网红黑料网的信息来源可靠吗？",
    answer: "我们坚持多方交叉验证原则，每条爆料均经过至少两个独立信源核实后才发布。同时我们会标注信息来源的可靠性等级，帮助读者判断信息可信度。对于未经证实的传闻，我们会明确标注「待核实」标签。",
  },
  {
    question: "如何向网红黑料网投稿或爆料？",
    answer: "我们欢迎所有吃瓜群众提供线索！你可以通过本站的投稿入口提交爆料信息，上传相关证据材料。我们承诺对爆料人信息严格保密，所有投稿都会经过专业编辑团队的审核与核实。",
  },
  {
    question: "网站上的内容会侵犯网红隐私权吗？",
    answer: "我们严格遵守相关法律法规，所有报道均基于已公开的信息或经过合法途径获取的材料。我们坚持新闻真实性和公共利益原则，不传播纯私人生活内容，聚焦于涉及公众利益和粉丝权益的事项。",
  },
  {
    question: "网红黑料网有移动端App吗？",
    answer: "目前我们提供移动端H5版本，适配手机和平板浏览器，你可以直接在浏览器中访问获取最佳阅读体验。移动端支持消息推送提醒，不错过任何一个大瓜。",
  },
  {
    question: "为什么有些网红的信息搜不到？",
    answer: "我们的内容库以真实性为前提，并非所有网红都存在可证实的黑料。如果某位网红没有出现在网站上，可能是因为目前没有关于他/她的可靠爆料信息。我们不会为了流量而编造虚假内容。",
  },
];

export const contactInfo = {
  title: "你有料，我来曝",
  subtitle: "欢迎广大吃瓜群众提供网红黑料线索，我们承诺严格保护爆料人隐私",
  description: "如果你掌握网红塌房、翻车、内幕的一手信息，或者发现了值得深扒的网红八卦线索，欢迎通过以下方式联系我们。真实爆料一经采用，将获得曝光推荐。",
};

export const appInfo = {
  title: "随时随地 想吃就吃",
  subtitle: "移动端H5版本已上线，浏览器打开即可体验",
  features: ["消息推送提醒，大瓜不错过", "夜间模式护眼，深夜吃瓜更舒适", "一键分享爆料，和好友一起吃瓜", "收藏夹功能，好瓜留着慢慢品"],
};